import { useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect } from "react";

const ScrollTop = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollTop;
